// modules
import { merge, interval } from 'rxjs'
import { combineEpics, ofType } from 'redux-observable'
import { filter, throttleTime, tap, map, ignoreElements } from 'rxjs/operators'
import * as R from 'ramda'
// actions
import { QUEUE_PUSH, QUEUE_SEND, queueSend } from './queue.action'
// views
import { getSocket } from '../socket'
import { getHook } from '../hooks'
// helper
import { handleRetryIteration } from './queue.helper'
// store
import { queueView } from './queue.view'

const queuePushEpic = action$ =>
  action$.pipe(
    ofType(QUEUE_PUSH),
    map(getSocket),
    filter(socket => socket.isOpen()),
    map(queueSend),
  )

const queueSendEpic = action$ =>
  merge(
    action$.pipe(
      ofType(QUEUE_SEND),
      throttleTime(2),
    ),
    interval(1000).pipe(tap(handleRetryIteration)),
  ).pipe(
    map(queueView),
    filter(
      queue => queue.length && getHook('shouldSend')() && getSocket().isOpen(),
    ),
    map(R.pluck('data')),
    map(actions => getHook('beforeSend')(actions)),
    tap(actions => getSocket().send(actions)),
    ignoreElements(),
  )

export default combineEpics(queuePushEpic, queueSendEpic)
